import { render, staticRenderFns } from "./MainDialog.vue?vue&type=template&id=4f88eac0&scoped=true"
import script from "./MainDialog.vue?vue&type=script&lang=ts"
export * from "./MainDialog.vue?vue&type=script&lang=ts"
import style0 from "./MainDialog.vue?vue&type=style&index=0&id=4f88eac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f88eac0",
  null
  
)

export default component.exports